// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"76fdccd049d37a193610","339":"4beee3bfef84afa32e56"}[chunkId] + ".js";
};